// extracted by mini-css-extract-plugin
export default {"body":"Input_body__kB3OZ","label":"Input_label__Lony0","input":"Input_input__AUPtw","input--dynamic-label":"Input_input--dynamic-label__bFsd5"};